module.exports = __webpack_public_path__ + "static/media/ship.3bf63b31.jpg";